import { render, staticRenderFns } from "./VideoList.vue?vue&type=template&id=7773b85f&scoped=true&"
import script from "./VideoList.vue?vue&type=script&lang=ts&"
export * from "./VideoList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7773b85f",
  null
  
)

export default component.exports